import * as actionTypes from "../actionTypes";

const initialState = {
  slider: [],
  categories: [],
  mostSellingProducts: [],
  topPickProducts: [],
  Grocery: [],
  Jewellery: [],
  Travel: [],
  Brands: [],
  FashionFlex: {},
  Food: [],

  isLoading: false,
  error: null,
  lastFetchedAt: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DASHBOARD_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case actionTypes.UPDATE_ALL_DASHBOARD_DATA:
      return {
        ...state,
        slider: action?.payload?.sliders || [],
        categories: action?.payload?.categories || [],
        mostSellingProducts: action?.payload?.sectionOne || [],
        topPickProducts: action?.payload?.sectionThree || [],
        Grocery: action?.payload?.sectionSix || [],
        Jewellery: action?.payload?.sectionSeven || [],
        Travel: action?.payload?.sectionEight || [],


        Brands: action?.payload?.brands || [],
        Food: action?.payload?.sectionTwo || [],
        FashionFlex:action?.payload?.sectionFour||{},
        isLoading: false,
        lastFetchedAt: Date.now(),
      };

    case actionTypes.DASHBOARD_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case actionTypes.RESET_DASHBOARD:
      return initialState;

    default:
      return state;
  }
};

export default reducer;